import { useDateRangeCtx } from '../DateRangeContext'
import { DateRangeTabs } from '../DateRangeTabs'
import { ABTestPanel } from '../widgets/ABTestPanel'
import { SegmentDrilldown } from '../widgets/SegmentDrilldown'

export function ABTestSection() {
  const { range } = useDateRangeCtx()
  return (
    <>
      <div className="section-toolbar">
        <DateRangeTabs />
        <div className="muted small">A/B-tab ignorerer variant-filteret (sammenligningen kræver begge), men respekterer audience-filteret</div>
      </div>
      <ABTestPanel range={range} />
      <SegmentDrilldown range={range} />
    </>
  )
}
